'use strict';

import '../../css/fields/paymentOptions.scss';
import { paymentOptionsElements } from "./elements/paymentOptionsElements";
import { EVENT_TOGGLE_ANONYMOUS_DONOR } from "../AnonymousDonor/AnonymousDonor";

export const PROVIDER = 'provider';
export const DONOR = 'donor';
export const MONTHLY = 'monthly';
export const SINGLE = 'single';

export default class PaymentOptions
{
    // Amount
    OTHER = 'other';
    amount = null;
    amountSets = {
        provider: [ 5, 25, 50 ],
        donorMonthly: [ 6, 8, 10 ],
        donorSingle: [ 15, 45, 75 ]
    };

    constructor(
        formType = PROVIDER,
        currentDonationAmount = '0.00',
        showMonthly = true, // Used from context of donor form
        anonymousDonor = null
    ) {
        this.elements = paymentOptionsElements();
        this.showMonthly = showMonthly;
        this.anonymousDonor = anonymousDonor;

        if (this.elements.donationAmount !== null) {
            this.formType = formType;
            this.currentDonationAmount = currentDonationAmount;
            this.amountButtonDown = this.onAmountButtonDown.bind(this);
            this.singleMontlyButtonDown = this.onSingleMonthlyButtonDown.bind(this);
            this.toggleAnonymousDonor = this.onToggleAnonymousDonor.bind(this);
            this.init();
            this.addEventListeners();
        }
    }

    init() {
        if (this.formType === DONOR) {
            // Last moment update, remove monthly from donor form
            //if (this.showMonthly) {
            //    this.elements.montlySingleRow.hidden = false;
            //    this.setAmounts(this.amountSets.donorMonthly);
            //} else {
                this.elements.singleOrMonthlyPayment.value = SINGLE;
                this.setAmounts(this.amountSets.donorSingle);
            //}
        }
        if (this.formType === PROVIDER) {
            this.setAmounts(this.amountSets.provider);
        }
    }

    addEventListeners() {
        this.elements.amountButtons.forEach(button => {
            button.addEventListener('mousedown', this.amountButtonDown);
        });
        if (this.formType === DONOR) {
            this.anonymousDonor.addEventListener(EVENT_TOGGLE_ANONYMOUS_DONOR, this.toggleAnonymousDonor);
            this.elements.monthlySingleButtons.forEach(button => {
                button.addEventListener('mousedown', this.singleMontlyButtonDown);
            });
        }
    }

    showValidationError() {
        this.elements.validationError.hidden = false;
    }

    hideValidationError() {
        this.elements.validationError.hidden = true;
    }

    showOther() {
        this.elements.other.hidden = false;
    }

    hideOther() {
        this.elements.other.hidden = true;
    }

    resetAmounts() {
        this.elements.amountButtons.forEach(button => {
            button.classList.remove('btn-primary');
        });
        this.elements.donationAmountSelect.value = null;
    }

    resetMonthlySingleButtons() {
        this.elements.monthlySingleButtons.forEach(button => {
            button.classList.remove('btn-primary');
        });
        this.elements.singleOrMonthlyPayment.value = null;
    }

    onAmountButtonDown(event) {
        const target = event.currentTarget;
        this.amount = target.getAttribute('data-amount');
        this.hideValidationError();
        this.resetAmounts();
        target.classList.add('btn-primary');
        if (this.amount === this.OTHER) {
            this.showOther();
            this.elements.donationAmountSelect.value = null;
        } else {
            this.hideOther();
            this.elements.donationAmount.value = null;
            this.elements.donationAmountSelect.value = this.amount;
        }
    }

    onSingleMonthlyButtonDown(event) {
        const target = event.currentTarget;
        const option = target.getAttribute('data-option');
        this.resetMonthlySingleButtons();
        this.resetAmounts();
        target.classList.add('btn-primary');
        if (option === MONTHLY) {
            this.setAmounts(this.amountSets.donorMonthly);
        }
        if (option === SINGLE) {
            this.setAmounts(this.amountSets.donorSingle);
        }
        this.elements.singleOrMonthlyPayment.value = option;
    }

    onToggleAnonymousDonor(event) {
        // Last minute update: Remove monthly payment from donor form as a whole
        //this.resetMonthlySingleButtons();
        //this.elements.montlySingleRow.hidden = event.detail.anonymousPayment;
        //if (event.detail.anonymousPayment) {
        //    this.setAmounts(this.amountSets.donorSingle);
        //    this.elements.singleOrMonthlyPayment.value = SINGLE;
        //} else {
        //    this.elements.singlePaymentButton.classList.add('btn-primary');
        //}
    }

    setAmounts(amounts) {
        const current = this.getCurrentDonationAmount();
        let currentFound = false;
        this.elements.amountButtons.forEach((button, index) => {
            if (typeof amounts[index] !== 'undefined') {
                if (current !== 0 && current === amounts[index]) {
                    button.classList.add('btn-primary');
                    currentFound = true;
                    this.elements.donationAmountSelect.value = current;
                }
                button.setAttribute('data-amount', amounts[index]);
                button.innerHTML = `&euro; ${amounts[index]}`;
            } else {
                button.setAttribute('data-amount', 'other');
                if (current !== 0 && !currentFound) {
                    button.classList.add('btn-primary');
                    this.showOther();
                    this.amount = this.OTHER;
                    this.elements.donationAmount.value = this.currentDonationAmount;
                }
            }
        });
    }

    getCurrentDonationAmount() {
        const currentDonationAmount = this.currentDonationAmount.split('.');
        if (typeof currentDonationAmount[1] === 'undefined') {
            return parseInt(currentDonationAmount[0]);
        }
        if (currentDonationAmount[1] !== '00') {
            return currentDonationAmount;
        }
        if (currentDonationAmount[1] === '00') {
            return parseInt(currentDonationAmount[0]);
        }
    }
}
